module.exports = __webpack_public_path__ + "assets/Segment6Detailed.d45b4f81e0d663daac8a288d28fa684c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Segment6Detailed.png
// module id = 558
// module chunks = 0